export default (store) => store;
